import { render, staticRenderFns } from "./MenuMobile.vue?vue&type=template&id=42c56ea4&scoped=true"
import script from "./MenuMobile.vue?vue&type=script&lang=js"
export * from "./MenuMobile.vue?vue&type=script&lang=js"
import style0 from "./MenuMobile.vue?vue&type=style&index=0&id=42c56ea4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c56ea4",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MainNav: require('/app/components/MainNav.vue').default,SubNav: require('/app/components/SubNav.vue').default})
